import notificacaoService from '../services/notificacaoService';
import { useNotificacao } from '../context/NotificacaoContext';
import { useAuth } from '../context/AuthContext';
import { useEffect } from 'react';
import { verificarAcessoAdministrador } from './auth';

// Hook personalizado para enviar notificações
export const useNotificador = () => {
    const { adicionarNotificacao } = useNotificacao();
    const { user } = useAuth();

    // Tipos de notificação disponíveis
    const tipos = {
        INFO: 'INFO',
        SUCCESS: 'SUCCESS',
        WARNING: 'WARNING',
        ERROR: 'ERROR',
        SYSTEM: 'SYSTEM',
        SUBSCRIPTION: 'SUBSCRIPTION',
        ACCOUNT: 'ACCOUNT',
        TASK: 'TASK',
        REMINDER: 'REMINDER'
    };

    // Função para enviar notificação para o usuário atual
    const enviarNotificacao = async (
        titulo: string,
        mensagem: string,
        tipoNotificacao = tipos.INFO,
        linkAcao?: string,
        textoAcao?: string
    ) => {
        if (!user) return;

        try {
            // Adicionar notificação localmente
            const notificacao = {
                guid: `local-${Date.now()}`,
                usuarioGuid: user.guid,
                titulo,
                mensagem,
                tipoNotificacao: tipoNotificacao as any,
                dataEnvio: new Date().toISOString(),
                lida: false,
                linkAcao,
                textoAcao
            };

            // Adicionar no contexto para atualização imediata da UI
            adicionarNotificacao(notificacao);

            // Se for administrador, também enviar para o backend para persistir
            //if (user.role === UsuarioPerfil.EMPRESA_ADMIN || user.role === UsuarioPerfil.THINKWAY_ADMIN) {
            await notificacaoService.enviarNotificacaoParaUsuario(
                user.guid,
                {
                    titulo,
                    mensagem,
                    tipoNotificacao: tipoNotificacao as any,
                    linkAcao,
                    textoAcao
                }
            );
            //}
        } catch (error) {
            console.error('Erro ao enviar notificação:', error);
        }
    };

    // Função para enviar notificação para todos os usuários do tenant (somente admin)
    const notificarTodosTenant = async (
        titulo: string,
        mensagem: string,
        tipoNotificacao = tipos.INFO,
        linkAcao?: string,
        textoAcao?: string
    ) => {
        if (!user || !verificarAcessoAdministrador(user.role)) {
            console.error('Apenas administradores podem enviar notificações para todos');
            return;
        }

        try {
            await notificacaoService.notificarTodosTenant({
                titulo,
                mensagem,
                tipoNotificacao: tipoNotificacao as any,
                linkAcao,
                textoAcao
            });

            // Adicionar também para o usuário atual para feedback imediato
            enviarNotificacao(titulo, mensagem, tipoNotificacao, linkAcao, textoAcao);
        } catch (error) {
            console.error('Erro ao notificar todos usuários:', error);
        }
    };

    // Retorna as funções e tipos
    return {
        enviarNotificacao,
        notificarTodosTenant,
        tipos
    };
};

// Componente para demonstrar uso das notificações (para fins de desenvolvimento)
// export const NotificacaoExemplos = () => {
//     const { enviarNotificacao, tipos } = useNotificador();
//     const { user } = useAuth();

//     useEffect(() => {
//         // Exemplos de notificações para demonstração
//         const exemplos = async () => {
//             // Somente enviar em ambiente de desenvolvimento
//             if (process.env.NODE_ENV !== 'development' || !user) return;

//             // Esperar um pouco para o usuário ver a UI primeiro
//             await new Promise(resolve => setTimeout(resolve, 3000));

//             // Enviar exemplos
//             enviarNotificacao(
//                 'Bem-vindo ao ThinkWay',
//                 'Obrigado por escolher nossa plataforma. Estamos aqui para ajudar no seu planejamento estratégico.',
//                 tipos.INFO,
//                 '/tw/dashboard',
//                 'Ver dashboard'
//             );

//             await new Promise(resolve => setTimeout(resolve, 2000));

//             enviarNotificacao(
//                 'Assinatura ativa',
//                 'Sua assinatura está ativa e você tem acesso a todos os recursos da plataforma.',
//                 tipos.SUCCESS
//             );

//             await new Promise(resolve => setTimeout(resolve, 2000));

//             enviarNotificacao(
//                 'Lembrete de reunião',
//                 'Você tem uma reunião agendada para amanhã às 14:00.',
//                 tipos.REMINDER,
//                 '/tw/calendar',
//                 'Ver agenda'
//             );
//         };

//         exemplos();
//     }, [user, enviarNotificacao, tipos]);

//     return null;
// };

export default useNotificador;
